import React, { useContext } from 'react';
import { Moon, Sun } from 'react-feather';
import { ThemeContext } from '../../context/ThemeContext';
import './ThemeToggle.scss';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  
  return (
    <button 
      className="theme-toggle" 
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="toggle-icon">
        {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
      </div>
      <span className="sr-only">
        {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
      </span>
    </button>
  );
};
